import {ONLINEHOST, QAHOST} from '../config'

export const requestUrl = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST


//跳转外链-用户端首页
// export const web_zc_home = 'https://www.emof.cn'
// export const web_emof_home = 'https://www.emof.cn/'
export const web_zc_home = 'https://www.emof.cn'
export const web_emof_home = 'https://www.emof.cn/'

export const web_emof_member = 'https://hygl.emof.cn' // 益魔方首页

export const img_url = 'https://hygl.emof.cn' //没用到

//跳转外链-机构设置 用不到先不换
export const web_emof_setting = 'https://www.emof.cn/'
//跳转外链-消息中心 用不到先不换
export const web_emof_news = 'https://www.emof.cn/'
//跳转外链-益会宝
// export const web_yhb = `http://yhb.emof.cn/`
export const web_yhb = `https://yhb.emof.cn/vw/`
export const web_yhb_detail = `${web_yhb}tiaoz?path=/meetDetail?id=`
export const web_yhb_member_detail = `${web_yhb}meetDetail?id=`

export const org_url = 'https://www.emof.cn'
//客服电话
export const service_phone = '400-999-6541'

//  总会左侧菜单
export const organizMenus = [
    {value: 0, label: '系统首页', icon: 'icon-jituanqiye', page: '/organization/index'},
    {
        value: 1,
        label: '会员通知',
        icon: 'icon-tongzhi2',
        page: '/organization/notice/list',
        childs: [
            {value: 0, label: '通知公告', page: '/organization/notice/list'},
            {value: 1, label: '短信群发', page: '/organization/message/list'},
            {value: 2, label: '短信提醒', page: '/organization/message/remind'},
            {value: 3, label: '邮件群发', page: '/organization/email/list'},
        ]
    },
    {
        value: 2,
        label: '会员设置',
        icon: 'icon-kequnguanli',
        page: '/organization/setup/level',
        childs: [
            {value: 0, label: '级别管理', page: '/organization/setup/level'},
            {value: 1, label: '标签管理', page: '/organization/setup/label'},
            {value: 3, label: '信息设置', page: '/organization/setup/information'},
            {value: 4, label: '会员说明', page: '/organization/setup/explain'},
            {value: 5, label: '证书设置', page: '/organization/setup/certificate'},
        ]
    },
    {
        value: 9,
        label: '积分管理',
        icon: 'icon-kequnguanli',
        page: '/organization/integral/setting',
        childs: [
            {value: 0, label: '积分设置', page: '/organization/integral/setting'},
        ]
    },
    {
        value: 3,
        label: '会员管理',
        icon: 'icon-renzhengyonghu',
        page: '/organization/members/list',
        childs: [
            {value: 0, label: '会员信息', page: '/organization/members/list'},
            {value: 5, label: '会员邀请', page: '/organization/setup/invitation'},
            {value: 1, label: '会员审核', page: '/organization/members/exam'}
        ]
    },
    {
        value: 8,
        label: '分会管理',
        icon: 'icon-teamwork-full',
        page: '/organization/members/orgList',
        childs: [
            {value: 0, label: '分会管理', page: '/organization/members/orgList'},
            // { value: 1, label: '分会邀请', page: '/organization/setup/binvitation' },
            // { value: 2, label: '分会审核', page: '/organization/members/orgExam' },
        ]
    },
    {
        value: 4,
        label: '费用管理',
        icon: 'icon-menzhenfeiyong',
        page: '/organization/fee/cost',
        childs: [
            {value: 0, label: '会费管理', page: '/organization/fee/cost'},
            {value: 1, label: '开票记录', page: '/organization/fee/invoice'},
            {value: 2, label: '支付设置', page: '/organization/fee/pay'},
            {value: 6, label: '短信套餐', page: '/organization/organ/billing'},
        ]
    },
    {
        value: 5,
        label: '机构管理',
        icon: 'icon-jigouguanli1',
        page: '/organization/organ/info',
        childs: [
            {value: 0, label: '机构信息', page: '/organization/organ/info'},
            {value: 1, label: '机构动态', page: '/organization/organ/dynamic'},
            {value: 2, label: '机构活动', page: '/organization/organ/activity'},
            {value: 3, label: '机构服务', page: '/organization/organ/server'},
            {value: 5, label: '子账号管理', page: '/organization/organ/account', role: 2},
            {value: 4, label: '密码管理', page: '/organization/organ/password'},
        ]
    },
    {
        value: 6,
        label: '客户服务',
        icon: 'icon-fuwuguanli',
        page: '/organization/server/serverList',
        childs: [
            {value: 0, label: '客服管理', page: '/organization/server/serverList'},
            // { value: 1, label: '常见问题', page: '/organization/server/question' },
            {value: 2, label: '意见反馈', page: '/organization/server/opinion'},
        ]
    },
    {value: 7, label: '会员统计', icon: 'icon-24gf-chartBarUpward', page: '/organization/statistics/statistics'},
    {
        value: 10,
        label: '帮助中心',
        icon: 'icon-kequnguanli',
        page: '/help',
        childs: [
            { value: 0, label: '帮助中心', page: '/help' },
        ]
    },
]
//  分会会左侧菜单
export const branchMenus = [
    {value: 0, label: '系统首页', icon: 'icon-jituanqiye', page: '/branch/index'},
    {
        value: 1,
        label: '会员通知',
        icon: 'icon-tongzhi2',
        page: '/branch/notice/list',
        childs: [
            {value: 0, label: '通知公告', page: '/branch/notice/list'},
            {value: 1, label: '短信群发', page: '/branch/message/list'},
        ]
    },
    {
        value: 2,
        label: '会员设置',
        icon: 'icon-kequnguanli',
        page: '/branch/setup/label',
        childs: [
            // { value: 0, label: '级别管理', page: '/branch/setup/level' },
            {value: 1, label: '标签管理', page: '/branch/setup/label'},
            // { value: 3, label: '信息设置', page: '/branch/setup/information' },
            {value: 4, label: '会员说明', page: '/branch/setup/explain'},
            {value: 5, label: '证书设置', page: '/branch/setup/certificate'},
        ]
    },
    {
        value: 3,
        label: '会员管理',
        icon: 'icon-kequnguanli',
        page: '/branch/members/list',
        childs: [
            {value: 0, label: '会员信息', page: '/branch/members/list'},
            {value: 2, label: '会员邀请', page: '/branch/setup/invitation'},
            {value: 1, label: '会员审核', page: '/branch/members/exam'}
        ]
    },
    {value: 8, label: '分会聘书', icon: 'icon-fileprotect', page: '/branch/members/fcertificate'},
    //
    // {
    //     value: 4,
    //     label: '费用管理',
    //     icon: 'icon-menzhenfeiyong',
    //     page: '/branch/fee/cost',
    //     childs: [
    //         { value: 0, label: '会费管理', page: '/branch/fee/cost' },
    //         { value: 1, label: '开票记录', page: '/branch/fee/invoice' },
    //         { value: 2, label: '支付设置', page: '/branch/fee/pay' },
    //     ]
    // },
    {
        value: 5,
        label: '机构管理',
        icon: 'icon-jigouguanli1',
        page: '/branch/organ/info',
        childs: [
            {value: 0, label: '机构信息', page: '/branch/organ/info'},
            {value: 1, label: '机构动态', page: '/branch/organ/dynamic'},
            {value: 2, label: '机构活动', page: '/branch/organ/activity'},
            {value: 3, label: '机构服务', page: '/branch/organ/server'},
            // { value: 5, label: '子账号管理', page: '/branch/organ/account',role:3 },
            {value: 4, label: '密码管理', page: '/branch/organ/password'},
        ]
    },
    {
        value: 6,
        label: '客户服务',
        icon: 'icon-fuwuguanli',
        page: '/branch/server/serverList',
        childs: [
            {value: 0, label: '客服管理', page: '/branch/server/serverList'},
            // { value: 1, label: '常见问题', page: '/branch/server/question' },
            {value: 2, label: '意见反馈', page: '/branch/server/opinion'},
        ]
    },
    {value: 7, label: '会员统计', icon: 'icon-24gf-chartBarUpward', page: '/branch/statistics/statistics'},
    {
        value: 10,
        label: '帮助中心',
        icon: 'icon-kequnguanli',
        page: '/help',
        childs: [
            { value: 0, label: '帮助中心', page: '/help' },
        ]
    },
]

//  总会设置分会权限菜单
export const powers = [
    {value: 0, label: '系统首页', isShow: true, dis: true},
    {
        value: 1,
        label: '会员通知',
        isShow: true,
        childs: [
            {value: 0, label: '通知公告', isShow: true},
            {value: 1, label: '短信群发', isShow: true},
        ]
    },
    {
        value: 2,
        label: '会员设置',
        isShow: true,
        childs: [
            // { value: 0, label: '级别管理',isShow:true},
            {value: 1, label: '标签管理', isShow: true},
            // { value: 3, label: '信息设置',isShow:true},
            {value: 4, label: '会员说明', isShow: true},
            {value: 5, label: '证书设置', isShow: true},
        ]
    },
    {
        value: 3,
        label: '会员管理',
        isShow: true,
        childs: [
            {value: 0, label: '会员信息', isShow: true},
            {value: 2, label: '会员邀请', isShow: true},
            {value: 1, label: '会员审核', isShow: true}
        ]
    },
    {value: 8, label: '分会聘书', isShow: true},
    {
        value: 5,
        label: '机构管理',
        isShow: true,
        childs: [
            {value: 0, label: '机构信息', isShow: true},
            {value: 1, label: '机构动态', isShow: true},
            {value: 2, label: '机构活动', isShow: true},
            {value: 3, label: '机构服务', isShow: true},
            {value: 5, label: '子账号管理', isShow: true},
            {value: 4, label: '密码管理', isShow: true},
        ]
    },
    {
        value: 6,
        label: '客户服务',
        isShow: true,
        childs: [
            {value: 0, label: '客服管理', isShow: true},
            // { value: 1, label: '常见问题',isShow:true},
            {value: 2, label: '意见反馈', isShow: true},
        ]
    },
    {value: 7, label: '会员统计', isShow: true, dis: true},
    {value: 10, label: '帮助中心', isShow: true, dis: true},
]
//  总会设置子管理员权限菜单
export const sonPowers = [
    {value: 0, label: '系统首页', isShow: true, dis: true},
    {
        value: 1,
        label: '会员通知',
        isShow: true,
        childs: [
            {value: 0, label: '通知公告', isShow: true},
            {value: 1, label: '短信群发', isShow: true},
        ]
    },
    {
        value: 2,
        label: '会员设置',
        isShow: true,
        childs: [
            {value: 0, label: '级别管理', isShow: true},
            {value: 1, label: '标签管理', isShow: true},
            {value: 3, label: '信息设置', isShow: true},
            {value: 4, label: '会员说明', isShow: true},
            {value: 5, label: '证书设置', isShow: true},
        ]
    },
    {
        value: 9,
        label: '积分管理',
        isShow: true,
        childs: [
            {value: 0, label: '积分设置', isShow: true},
        ]
    },
    {
        value: 3,
        label: '会员管理',
        isShow: true,
        childs: [
            {value: 0, label: '会员信息', isShow: true},
            {value: 5, label: '会员邀请', isShow: true},
            {value: 1, label: '会员审核', isShow: true},
        ]
    },
    {
        value: 8,
        label: '分会管理',
        isShow: true,
        childs: [
            {value: 0, label: '分会管理', isShow: true},
            // { value: 1, label: '分会邀请', isShow:true},
            // { value: 2, label: '分会审核', isShow:true},
        ]
    },
    {
        value: 4,
        label: '费用管理',
        isShow: true,
        childs: [
            {value: 0, label: '会费管理', isShow: true},
            {value: 1, label: '开票记录', isShow: true},
            {value: 2, label: '支付设置', isShow: true},
            {value: 6, label: '短信套餐', isShow: true},
        ]
    },
    {
        value: 5,
        label: '机构管理',
        isShow: true,
        childs: [
            {value: 0, label: '机构信息', isShow: true},
            {value: 1, label: '机构动态', isShow: true},
            {value: 2, label: '机构活动', isShow: true},
            {value: 3, label: '机构服务', isShow: true},
            {value: 4, label: '密码管理', isShow: true},
            // { value: 5, label: '子账号管理',isShow:true },
        ]
    },
    {
        value: 6,
        label: '客户服务',
        isShow: true,
        childs: [
            {value: 0, label: '客服管理', isShow: true},
            // { value: 1, label: '常见问题', isShow:true},
            {value: 2, label: '意见反馈', isShow: true},
        ]
    },
    {value: 7, label: '会员统计', isShow: true},
    { value: 10, label: '帮助中心',isShow:true },
]

//  分会设置子权限菜单
export const sonFhpowers = [
    {value: 0, label: '系统首页', isShow: true, dis: true},
    {
        value: 1,
        label: '会员通知',
        isShow: true,
        childs: [
            {value: 0, label: '通知公告', isShow: true},
            {value: 1, label: '短信群发', isShow: true},
        ]
    },
    {
        value: 2,
        label: '会员设置',
        isShow: true,
        childs: [
            // { value: 0, label: '级别管理',isShow:true},
            {value: 1, label: '标签管理', isShow: true},
            // { value: 3, label: '信息设置',isShow:true},
            {value: 4, label: '会员说明', isShow: true},
            {value: 5, label: '证书设置', isShow: true},
        ]
    },
    {
        value: 3,
        label: '会员管理',
        isShow: true,
        childs: [
            {value: 0, label: '会员信息', isShow: true},
            {value: 2, label: '会员邀请', isShow: true},
            {value: 1, label: '会员审核', isShow: true}
        ]
    },
    {value: 8, label: '分会聘书', isShow: true},
    {
        value: 5,
        label: '机构管理',
        isShow: true,
        childs: [
            {value: 0, label: '机构信息', isShow: true},
            {value: 1, label: '机构动态', isShow: true},
            {value: 2, label: '机构活动', isShow: true},
            {value: 3, label: '机构服务', isShow: true},
            // { value: 5, label: '子账号管理',isShow:true },
            {value: 4, label: '密码管理', isShow: true},
        ]
    },
    {
        value: 6,
        label: '客户服务',
        isShow: true,
        childs: [
            {value: 0, label: '客服管理', isShow: true},
            {value: 1, label: '常见问题', isShow: true},
            {value: 2, label: '意见反馈', isShow: true},
        ]
    },
    {value: 7, label: '会员统计', isShow: true, dis: true},
]

export const memberMenus = [
    {value: 0, label: '首页', icon: 'icon-shouye', page: '/member/index'},
    {value: 1, label: '通知公告', icon: 'icon-tongzhi1', page: '/member/notice'},
    {value: 2, label: '机构动态', icon: 'icon-tongzhi', page: '/member/active'},
    {value: 3, label: '活动管理', icon: 'icon-jiangzhang', page: '/member/metting'},
    {value: 4, label: '服务中心', icon: 'icon--fuwu', page: '/member/service/list'},
    {value: 5, label: '会员中心', icon: 'icon-setting-user', page: '/member/vip'},
    {
        value: 6,
        label: '账号管理',
        icon: 'icon-mimashezhi',
        page: '/member/account',
        childs: [
            {value: 0, label: '账号设置', page: '/member/account'},
            {value: 1, label: '修改密码', page: '/member/password'},
        ]
    },
    {value: 7, label: '客服中心', icon: 'icon-kefu_full', page: '/member/call'},
    {
        value: 10,
        label: '帮助中心',
        icon: 'icon-kequnguanli',
        page: '/help',
        childs: [
            { value: 0, label: '帮助中心', page: '/help' },
        ]
    },
]

export const vipMenus = [
    {value: 0, label: '基本信息', page: '/member/vip/basic'},
    {value: 1, label: '会员证书', page: '/member/vip/certificate'},
    {value: 2, label: '会费信息', page: '/member/vip/ship'},
]

export const callMenus = [
    {value: 0, label: '机构介绍', page: '/member/call/intro'},
    {value: 1, label: '联系我们', page: '/member/call/contact'},
    {value: 2, label: '意见建议', page: '/member/call/idea'},
]

export const feeList = [
    {
        value: 0,
        label: '全部'
    },
    {
        value: 1,
        label: '已缴费'
    },
    {
        value: 2,
        label: '未缴费'
    },
]
export const endTime = [
    {
        value: 0,
        label: '全部'
    },
    {
        value: 30,
        label: '30天内到期'
    },
    {
        value: 15,
        label: '15天内到期'
    },
    {
        value: 7,
        label: '7天内到期'
    },
    {
        value: -1,
        label: '已到期'
    },
]
export const lockList = [
    {
        value: 0,
        label: '全部'
    },
    {
        value: 1,
        label: '已锁定'
    },
    {
        value: 2,
        label: '未锁定'
    },
    {
        value: 3,
        label: '已退会'
    },
    {
        value: 4,
        label: '未退会'
    },
]


export const remind_menus = [
    {
        title: '全部',
        count: 0,
        role: [1,2,3,4,5],
        type: 0,
    },
    {
        title: '待审核会员',
        count: 0,
        role: [1],
        type: 1,
    },
    {
        title: '待审核通知',
        count: 0,
        role: [2],
        type: 2,
    },
    {
        title: '待审核动态',
        count: 0,
        role: [3],
        type: 3,
    },
    {
        title: '待审核会费',
        count: 0,
        role: [4],
        type: 4,
    },
    {
        title: '其他',
        count: 0,
        role: [5],
        type: 5,
    }]

//自定义证书 机构判断
export const custom_certificate = (mid) =>  [918,931].includes(mid)